// One chapter order and numbering for the cover and every page in its book.
export interface BookChapter {
    key: string;
    title: string;
    numeral: string;
}

function roman(value: number): string {
    let out = '';
    for (const [n, token] of [[1000, 'M'], [900, 'CM'], [500, 'D'], [400, 'CD'], [100, 'C'], [90, 'XC'], [50, 'L'], [40, 'XL'], [10, 'X'], [9, 'IX'], [5, 'V'], [4, 'IV'], [1, 'I']] as const) {
        while (value >= n) { out += token; value -= n; }
    }
    return out;
}

export function bookChapters(book: { chapters: { id: string; name: string }[] }): BookChapter[] {
    return [{ key: 'atlas', title: 'Atlas' }, { key: 'almanac', title: 'Almanac' },
        ...book.chapters.map(article => ({ key: article.id, title: article.name })),
        { key: 'history', title: 'History' }, { key: 'gazetteer', title: 'Gazetteer' }, { key: 'index', title: 'Index' }]
        .map((chapter, i) => ({ ...chapter, numeral: roman(i + 1) }));
}
